import { Component, OnInit } from '@angular/core';
import { GeneralFormBase } from 'src/app/models/general-form-base';
import { GeneralFormComponent } from '../../controls/general-form/general-form.component';

@Component({
  selector: 'app-rtema-solicitud',
  templateUrl: './rtema-solicitud.component.html',
  styleUrls: ['./rtema-solicitud.component.css']
})
export class RtemaSolicitudComponent extends GeneralFormComponent implements OnInit {

  configuracionRescatada: string | null = null;
  configuracionesGuardadas: { [idRegistro: string]: string } = {}; 
  cartuchosPorRegistro: { [idRegistro: string]: any[] } = {}; 

  public ngOnInit() {
    super.ngOnInit();
    setTimeout(() => {
      this.InicializarInteracciones();
    }, 800);
  }

  ObtenerIdSeguro(filaCruda?: any): string {
    let id: any = null;
    if (filaCruda) {
        id = filaCruda.IdTemaSolicitud || filaCruda.Pk || (filaCruda.findItem ? filaCruda.findItem.IdTemaSolicitud : null);
    }
    if (!id && this.modelo && this.modelo.modelo) {
        id = this.modelo.modelo.IdTemaSolicitud || this.modelo.modelo.Pk;
    }
    if (!id || id === "-1" || id === 0 || id === "0") return "";
    return String(id).trim();
  }

  ObtenerGrillaActiva() {
    if (this.componentsContainer && this.componentsContainer.Tables) {
      let grillas = this.componentsContainer.Tables.filter((t: any) => t.name === 'GridAuxiliares');
      return grillas.length > 0 ? grillas[grillas.length - 1] : null;
    }
    return null;
  }

  InicializarInteracciones() {
    const checkAuxiliares = this.form.get('RequiereAuxiliares');
    if (checkAuxiliares) {
      let inicial = (checkAuxiliares.value === true || checkAuxiliares.value === 'true' || checkAuxiliares.value === 'True');
      this.AlternarGrillaAuxiliares(inicial);
      checkAuxiliares.valueChanges.subscribe((marcado: any) => {
        let isChecked = (marcado === true || marcado === 'true' || marcado === 'True');
        this.AlternarGrillaAuxiliares(isChecked);
      });
    }

    const comboResponsable = this.form.get('IdUsuarioResponsable');
    if (comboResponsable) {
      this.AlternarMensajeAmarillo(comboResponsable.value);
      comboResponsable.valueChanges.subscribe((valor: any) => {
        this.AlternarMensajeAmarillo(valor); 
      });
    }
  }

  AlternarGrillaAuxiliares(mostrar: boolean) {
    if (this.Pagina && this.Pagina.ConfigPage && this.Pagina.ConfigPage.Controls) {
      let panel = this.Pagina.ConfigPage.Controls.find((c: any) => c.Name === 'PanelTemaSolicitud');
      if (panel && panel.Controls) {
        let grillaConfig = panel.Controls.find((c: any) => c.Name === 'GridAuxiliares');
        if (grillaConfig) grillaConfig.Hidden = !mostrar; 
      }
    }
  }

  AlternarMensajeAmarillo(valor: any) {
    if (this.Pagina && this.Pagina.ConfigPage && this.Pagina.ConfigPage.Controls) {
      let panel = this.Pagina.ConfigPage.Controls.find((c: any) => c.Name === 'PanelTemaSolicitud');
      if (panel && panel.Controls) {
        let mensajeConfig = panel.Controls.find((c: any) => c.Name === 'MsgBarContacto');
        if (mensajeConfig) mensajeConfig.Hidden = (valor !== null && valor !== undefined && valor !== "");
      }
    }
  }

  public GuardarForm(form: any, config?: any) {
    this.EmpaquetarConfiguracion();
    super.GuardarForm(form, config);
  }

  EmpaquetarConfiguracion() {
    const checkAuxiliares = this.form.get('RequiereAuxiliares');
    let requiresAux = checkAuxiliares ? (checkAuxiliares.value === true || checkAuxiliares.value === 'true' || checkAuxiliares.value === 'True') : false;

    let arrayAuxiliaresRobustos: any[] = [];
    let idRegistroActual = this.ObtenerIdSeguro();

    if (requiresAux) {
      let gridAuxiliares = this.ObtenerGrillaActiva();
      if (gridAuxiliares) {
        let seleccionados = [];
        if (typeof gridAuxiliares.GetSelectedItems === 'function') {
            seleccionados = gridAuxiliares.GetSelectedItems() || [];
        } else {
            seleccionados = gridAuxiliares.selectedItems || [];
        }
        
        arrayAuxiliaresRobustos = seleccionados.map((fila: any) => {
          return { IdUsuario: fila.IdUsuario, NombreUsuario: fila.NombreUsuario, Email: fila.Email, AreaEmpresa: fila.AreaEmpresa || "", Role: fila.Role || "" };
        });
      }
    }

    let configObj: any = {};
    if (this.modelo && this.modelo.modelo && this.modelo.modelo.Configuracion) {
      try { configObj = JSON.parse(this.modelo.modelo.Configuracion); } catch(e) { }
    }
    
    configObj.UsuariosAuxiliares = arrayAuxiliaresRobustos;
    let jsonFinal = JSON.stringify(configObj);
    
    this.modelo.modelo.Configuracion = jsonFinal;

    if (idRegistroActual) {
        this.configuracionesGuardadas[idRegistroActual] = jsonFinal;
    }
  }

  public OnDataTableEditHandler(event: any) {
    super.OnDataTableEditHandler(event);
    
    let filaCruda = event.data ? event.data : (event.Item ? event.Item : event);
    let idRegistroActual = this.ObtenerIdSeguro(filaCruda);
    if (!idRegistroActual) return;

    if (this.configuracionesGuardadas[idRegistroActual]) {
        filaCruda.Configuracion = this.configuracionesGuardadas[idRegistroActual];
    }
    
    this.configuracionRescatada = filaCruda.Configuracion || (this.modelo && this.modelo.modelo ? this.modelo.modelo.Configuracion : null);
    let hayAuxiliares = false;
    let auxiliaresArray: any[] = [];

    if (this.configuracionRescatada) {
      try {
        let configObj = JSON.parse(this.configuracionRescatada);
        if (configObj && configObj.UsuariosAuxiliares) {
          if (configObj.UsuariosAuxiliares.length > 0) hayAuxiliares = true;
          auxiliaresArray = configObj.UsuariosAuxiliares;
        }
      } catch(e) {}
    }

    this.cartuchosPorRegistro[idRegistroActual] = auxiliaresArray;

    const checkAuxiliares = this.form.get('RequiereAuxiliares');
    if (checkAuxiliares) {
      checkAuxiliares.setValue(hayAuxiliares);
    }

    // Aprovechamos los milisegundos que tarda la red en traer los datos para sembrar la memoria.
    if (hayAuxiliares && auxiliaresArray.length > 0) {
        let intentos = 0;
        let intervaloPreCarga = setInterval(() => {
            intentos++;
            let gridViva = this.ObtenerGrillaActiva();
            
            // Inyectamos la data en la grilla apenas nace y ANTES de que el Ajax regrese
            if (gridViva) {
                gridViva.selectedItems = [...auxiliaresArray];
            }
            
            // Detenemos el asedio después de 300ms (tiempo suficiente para cubrir la red)
            if (intentos > 30) {
                clearInterval(intervaloPreCarga);
            }
        }, 10);
    }
  }

  public OnLoadGridHandler(event: any) {
    super.OnLoadGridHandler(event);
    
    if (event && event.controlName === "GridAuxiliares") {
      let idRegistroActual = this.ObtenerIdSeguro();
      if (!idRegistroActual) return;

      let gridInstancia = event.instancia || this.ObtenerGrillaActiva();
      let cartuchoCorrespondiente = this.cartuchosPorRegistro[idRegistroActual];
      
      if (gridInstancia) {
          // Refuerzo de seguridad: Garantizamos que la memoria quede perfecta post-carga
          if (cartuchoCorrespondiente && cartuchoCorrespondiente.length > 0) {
              gridInstancia.selectedItems = [...cartuchoCorrespondiente];
          } else {
              gridInstancia.selectedItems = [];
          }
      }
    }
  }

  public Limpiar(callback: any = null, action?: any) {
    this.configuracionRescatada = null;

    if(action == undefined){
      let gridAuxiliares = this.ObtenerGrillaActiva();
      if (gridAuxiliares) gridAuxiliares.selectedItems = [];
      this.ClearModel();
    }
    
    this.utility.SetFieldsToModel(this.modelo.modelo, null);
    if (callback) callback(this.modelo);
    this.SetModelToControls();
    this.parentClearCall.next({ modelo: this.modelo, action: action });
    this.SetProcesando(false);
  }

  public OnActionEventHandler(event: any) {
    if(event.Action == "ClearModel"){
      if(event.Table && event.Table == "DataTables_RTemaTipoSolicitud"){
        super.Limpiar();
        super.ClearModel();
      }
    }
    super.OnActionEventHandler(event);
  }
}